import { render, staticRenderFns } from "./DiscountNewPage.vue?vue&type=template&id=34dd7346"
import script from "./DiscountNewPage.vue?vue&type=script&lang=ts"
export * from "./DiscountNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports